import { render, staticRenderFns } from "./step01.vue?vue&type=template&id=29871226"
import script from "./step01.vue?vue&type=script&lang=js"
export * from "./step01.vue?vue&type=script&lang=js"
import style0 from "./step01.vue?vue&type=style&index=0&id=29871226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports